<template>
  <v-content class="experience-organizations page">
    <can I="list" a="ExperienceOrganization">
      <v-container>
        <v-toolbar flat class="transparent">
          <v-breadcrumbs
            class="pl-0"
            :items="[
              { exact: true, text: 'Admin', to: '/dashboard' },
              { exact: true, text: 'Experience Organizations', to: '/experience_organizations' },
            ]"
          >
            <v-icon slot="divider">mdi-chevron-right</v-icon>
          </v-breadcrumbs>

          <v-spacer />

          <v-tooltip left>
            <v-btn small flat fab slot="activator" @click="refresh">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
            <span>Refresh</span>
          </v-tooltip>
          <can I="create" a="ExperienceOrganization">
            <v-tooltip left>
              <v-btn small flat fab slot="activator" to="/experience_organizations/new">
                <v-icon>mdi-plus</v-icon>
              </v-btn>
              <span>Add experience organization</span>
            </v-tooltip>
          </can>
        </v-toolbar>

        <v-card dark toolbar>
          <v-toolbar flat class="transparent">
            <v-card-title>
              <div class="headline">Experience Organizations</div>
            </v-card-title>

            <v-spacer />

            <v-text-field
              placeholder="Search"
              prepend-icon="mdi-magnify"
              type="search"
              v-model="search"
              @keyup.enter="filter"
            />

            <v-btn @click="filter" color="secondary">Filter</v-btn>
          </v-toolbar>

          <v-data-table
            :headers="headers"
            :items="active"
            :loading="loading"
            :total-items="total"
            :pagination.sync="pagination"
            @update:pagination="filter"
            must-sort
          >
            <template slot="items" slot-scope="{ item }">
              <td>{{ item.id }}</td>
              <td>
                <router-link :to="`/experience_organizations/${item.id}`">
                  <span>{{ item.name }}</span>
                </router-link>
              </td>
              <td>
                {{ item.industry }}
              </td>
              <td>{{ item.experiencesCount }}</td>
              <td>{{ new Date(item.updatedAt) | date('HH:mm MMM do ’yy') }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-container>
    </can>
  </v-content>
</template>

<script>
// Helpers
import _ from 'lodash'
import { mapState } from 'vuex'

// Vue Component
export default {
  name: 'ExperienceOrganizationsList',

  created() {
    this.$store.dispatch('admin/experience_organizations/search', {
      search: this.search,
      filters: { ...this.filters },
      ...this.pagination,
    })
  },

  data() {
    return {
      // Search and filters
      search: this.$route.query.search || '',
      filters: {},
      // Table Configuration
      headers: [
        { text: 'ID', value: 'id', align: 'left' },
        { text: 'Name', value: 'name.sort' },
        { text: 'Industry', value: 'industry' },
        { text: 'Count', value: 'experiences_count' },
        { text: 'Last updated', value: 'updatedAt' },
      ],
      pagination: { sortBy: 'id', descending: false, rowsPerPage: 25 },
    }
  },

  computed: {
    ...mapState('admin/experience_organizations', [
      'active',
      'loading',
      'total',
      'page',
      'rowsPerPage',
    ]),
  },

  methods: {
    refresh() {
      this.$store.dispatch('admin/experience_organizations/search')
    },

    filter() {
      // Update URL
      this.$router.replace(
        Object.assign({}, this.$route, {
          query: _.pickBy({ ...this.filters, search: this.search }, _.identity),
        })
      )

      // Fetch new data that matches filters and search
      this.$store.dispatch('admin/experience_organizations/search', {
        filters: this.filters,
        search: this.search,
        ...this.pagination,
      })
    },
  },
}
</script>
